import { PhoneScreen } from "./phone-screen";

export default PhoneScreen